var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeTopReviewer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  viewBox: "0 0 680 680",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "outerG",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7BA35E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#5C8240"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3E5E28"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "midG",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5A7E3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#466830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2E4A1E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "innerG",
  x1: 0,
  y1: 0,
  x2: 0.8,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4E7232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#3A5C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2A4418"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "iconG",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B8D4A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8AB86A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "leafG",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#A8CC88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#6A9848"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ribbonG",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8AB86A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#5A7E3A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "badgeClip"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 290
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "innerClip"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 230
})))), /*#__PURE__*/React.createElement("circle", {
  cx: 344,
  cy: 344,
  r: 296,
  fill: "#1A2E10",
  opacity: 0.4,
  style: {
    fill: "rgb(26, 46, 16)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.4,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 296,
  fill: "url(#outerG)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 296,
  fill: "none",
  stroke: "#8FC06A",
  strokeWidth: 3,
  opacity: 0.5,
  style: {
    fill: "none",
    stroke: "rgb(143, 192, 106)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 288,
  fill: "none",
  stroke: "#2E4A1E",
  strokeWidth: 2,
  opacity: 0.6,
  style: {
    fill: "none",
    stroke: "rgb(46, 74, 30)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.6,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 278,
  fill: "url(#midG)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 278,
  fill: "none",
  stroke: "#7BA35E",
  strokeWidth: 1.5,
  opacity: 0.4,
  style: {
    fill: "none",
    stroke: "rgb(123, 163, 94)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.4,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 248,
  fill: "none",
  stroke: "#2A4418",
  strokeWidth: 3,
  style: {
    fill: "none",
    stroke: "rgb(42, 68, 24)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 245,
  fill: "none",
  stroke: "#7BA35E",
  strokeWidth: 1,
  opacity: 0.3,
  style: {
    fill: "none",
    stroke: "rgb(123, 163, 94)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.3,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 238,
  fill: "url(#innerG)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#innerClip)",
  opacity: 0.08,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.08,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("line", {
  x1: 160,
  y1: 100,
  x2: 160,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 178,
  y1: 100,
  x2: 178,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 196,
  y1: 100,
  x2: 196,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 214,
  y1: 100,
  x2: 214,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 232,
  y1: 100,
  x2: 232,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 250,
  y1: 100,
  x2: 250,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 268,
  y1: 100,
  x2: 268,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 286,
  y1: 100,
  x2: 286,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 304,
  y1: 100,
  x2: 304,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 322,
  y1: 100,
  x2: 322,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 100,
  x2: 340,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 358,
  y1: 100,
  x2: 358,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 376,
  y1: 100,
  x2: 376,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 394,
  y1: 100,
  x2: 394,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 412,
  y1: 100,
  x2: 412,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 430,
  y1: 100,
  x2: 430,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 448,
  y1: 100,
  x2: 448,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 466,
  y1: 100,
  x2: 466,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 484,
  y1: 100,
  x2: 484,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 502,
  y1: 100,
  x2: 502,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 520,
  y1: 100,
  x2: 520,
  y2: 580,
  stroke: "#1A2E10",
  strokeWidth: 5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(26, 46, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  fill: "#E8F0DC",
  opacity: 0.9,
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.9,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "translate(0,0)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(36, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(72, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(108, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(144, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(180, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(216, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(252, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(288, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "340,72 345,86 360,86 348,95 352,110 340,102 328,110 332,95 320,86 335,86",
  transform: "rotate(324, 340, 340)",
  style: {
    fill: "rgb(232, 240, 220)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  fill: "#B8D4A0",
  opacity: 0.5,
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(18, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(54, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(90, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(126, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(162, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(198, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(234, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(270, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(306, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 65,
  r: 3,
  transform: "rotate(342, 340, 340)",
  style: {
    fill: "rgb(184, 212, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "topArc",
  d: "M160,340 A180,180 0 0,1 520,340",
  fill: "none",
  style: {
    fill: "none",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "'Georgia', serif",
  fontSize: 38,
  fontWeight: 700,
  fill: "#C8E0A8",
  letterSpacing: 6,
  style: {
    fill: "rgb(200, 224, 168)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, serif",
    fontSize: 38,
    fontWeight: 700,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("textPath", {
  href: "#topArc",
  startOffset: "50%",
  textAnchor: "middle",
  style: {
    fill: "rgb(200, 224, 168)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, serif",
    fontSize: 38,
    fontWeight: 700,
    textAnchor: "middle",
    dominantBaseline: "auto"
  }
}, "TOP REVIEWER")), /*#__PURE__*/React.createElement("g", {
  fill: "url(#leafG)",
  stroke: "#3A5C24",
  strokeWidth: 0.8,
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M260,470 Q255,400 270,310",
  fill: "none",
  stroke: "#6A9848",
  strokeWidth: 2.5,
  style: {
    fill: "none",
    stroke: "rgb(106, 152, 72)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "2.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 248,
  cy: 440,
  rx: 18,
  ry: 8,
  transform: "rotate(-25, 248, 440)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 244,
  cy: 410,
  rx: 18,
  ry: 8,
  transform: "rotate(-20, 244, 410)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 242,
  cy: 380,
  rx: 17,
  ry: 7,
  transform: "rotate(-15, 242, 380)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 244,
  cy: 350,
  rx: 16,
  ry: 7,
  transform: "rotate(-10, 244, 350)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 250,
  cy: 325,
  rx: 15,
  ry: 6,
  transform: "rotate(-5, 250, 325)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 272,
  cy: 435,
  rx: 18,
  ry: 8,
  transform: "rotate(20, 272, 435)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 270,
  cy: 405,
  rx: 17,
  ry: 7,
  transform: "rotate(15, 270, 405)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 268,
  cy: 375,
  rx: 16,
  ry: 7,
  transform: "rotate(10, 268, 375)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 270,
  cy: 348,
  rx: 15,
  ry: 6,
  transform: "rotate(5, 270, 348)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  fill: "url(#leafG)",
  stroke: "#3A5C24",
  strokeWidth: 0.8,
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M420,470 Q425,400 410,310",
  fill: "none",
  stroke: "#6A9848",
  strokeWidth: 2.5,
  style: {
    fill: "none",
    stroke: "rgb(106, 152, 72)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "2.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 432,
  cy: 440,
  rx: 18,
  ry: 8,
  transform: "rotate(25, 432, 440)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 436,
  cy: 410,
  rx: 18,
  ry: 8,
  transform: "rotate(20, 436, 410)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 438,
  cy: 380,
  rx: 17,
  ry: 7,
  transform: "rotate(15, 438, 380)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 436,
  cy: 350,
  rx: 16,
  ry: 7,
  transform: "rotate(10, 436, 350)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 430,
  cy: 325,
  rx: 15,
  ry: 6,
  transform: "rotate(5, 430, 325)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 408,
  cy: 435,
  rx: 18,
  ry: 8,
  transform: "rotate(-20, 408, 435)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 410,
  cy: 405,
  rx: 17,
  ry: 7,
  transform: "rotate(-15, 410, 405)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 412,
  cy: 375,
  rx: 16,
  ry: 7,
  transform: "rotate(-10, 412, 375)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 410,
  cy: 348,
  rx: 15,
  ry: 6,
  transform: "rotate(-5, 410, 348)",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("rect", {
  x: 305,
  y: 250,
  width: 70,
  height: 95,
  rx: 6,
  fill: "url(#iconG)",
  stroke: "#3A5C24",
  strokeWidth: 2,
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M355,250 L375,250 L375,270 L355,270 Z",
  fill: "#9CC478",
  stroke: "#3A5C24",
  strokeWidth: 1.2,
  style: {
    fill: "rgb(156, 196, 120)",
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.2px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M355,250 L375,270",
  fill: "none",
  stroke: "#3A5C24",
  strokeWidth: 1.2,
  style: {
    fill: "none",
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.2px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 318,
  y1: 282,
  x2: 358,
  y2: 282,
  stroke: "#3A5C24",
  strokeWidth: 2,
  strokeLinecap: "round",
  opacity: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 318,
  y1: 296,
  x2: 350,
  y2: 296,
  stroke: "#3A5C24",
  strokeWidth: 2,
  strokeLinecap: "round",
  opacity: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 318,
  y1: 310,
  x2: 355,
  y2: 310,
  stroke: "#3A5C24",
  strokeWidth: 2,
  strokeLinecap: "round",
  opacity: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 318,
  y1: 324,
  x2: 345,
  y2: 324,
  stroke: "#3A5C24",
  strokeWidth: 2,
  strokeLinecap: "round",
  opacity: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M330,266 L337,274 L352,258",
  fill: "none",
  stroke: "#2A4418",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style: {
    fill: "none",
    stroke: "rgb(42, 68, 24)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "3.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 478,
  r: 38,
  fill: "#3A5C24",
  stroke: "#7BA35E",
  strokeWidth: 2,
  style: {
    fill: "rgb(58, 92, 36)",
    stroke: "rgb(123, 163, 94)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 478,
  r: 30,
  fill: "url(#innerG)",
  stroke: "#6A9848",
  strokeWidth: 1.5,
  style: {
    stroke: "rgb(106, 152, 72)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M324,478 L334,490 L358,464",
  fill: "none",
  stroke: "#B8D4A0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style: {
    fill: "none",
    stroke: "rgb(184, 212, 160)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  fill: "url(#ribbonG)",
  stroke: "#3A5C24",
  strokeWidth: 1.2,
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.2px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M310,508 L280,575 L300,555 L290,590 L320,530 L322,510 Z",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.2px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M370,508 L400,575 L380,555 L390,590 L360,530 L358,510 Z",
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.2px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M312,500 Q340,525 368,500",
  fill: "url(#ribbonG)",
  stroke: "#3A5C24",
  strokeWidth: 1,
  style: {
    stroke: "rgb(58, 92, 36)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M180,220 A200,200 0 0,1 340,130",
  fill: "none",
  stroke: "#B8D4A0",
  strokeWidth: 2,
  opacity: 0.12,
  style: {
    fill: "none",
    stroke: "rgb(184, 212, 160)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.12,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeTopReviewer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badgeTopReviewer.722546ad3edd9e60f596e52913026e6b.svg";